<div class="focused-timeline-wrapper">
  <div class="focused-timeline-label">
    <ng-container *ngIf="isObjectEnabledProject; else shapeLabel">
      <h3-focused-annotation-label></h3-focused-annotation-label>
    </ng-container>
    <ng-template #shapeLabel>
      <h3-objectless-shape-label
        [shapeStore]="objectlessShapeStore$ | async"
      ></h3-objectless-shape-label>
    </ng-template>
    <span id="storeId" *ngIf="storeId$ | async as storeId">
      #{{ storeId }}
    </span>
  </div>
  <div class="focused-timeline-container">
    <h3-frame
      *ngFor="let frameNumber of frames$ | async"
      [frameNumber]="frameNumber"
    ></h3-frame>
  </div>
</div>
